import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  class: "h1",
  style: {"text-transform":"uppercase"}
}
const _hoisted_5 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_7 = {
  key: 0,
  class: "field form-group"
}
const _hoisted_8 = {
  key: 1,
  class: "auth-error"
}
const _hoisted_9 = { class: "field form-group d-flex align-items-center justify-content-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)

import {
  ref,
  computed,
  onMounted,
  watch,
  getCurrentInstance,
} from "vue";

import { AdapterApiService } from "@pages/_adapter";
import { notify } from "@/app/notifications";
import { AdapterAuthService } from "./adapter";
import { useRoute, useRouter } from "vue-router";
// Определение пропсов компонента
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'forgot-password-page',
  props: {
  isCompact: { type: Boolean, value: true },
  msg: { type: String, default: "" },
},
  setup(__props) {

// Импорты из Vue 3 Composition API
const router = useRouter();
const props = __props;
const isAuthNoError = ref(true);
const authErrorMessage = ref("Wrong login");
const adapter = AdapterAuthService.getInstance();
const email = ref("");
const Password = ref("");
const isPassword = ref(true);
const route = useRoute();
// const instance = getCurrentInstance();
const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  localStorage.setItem("locale", route.query?.lng.toString() || "cz");
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;
  // const res = await adapter.getCurrentUser();
  // console.log(`res`, res);
  // const res = await adapter.getCurrentUser();
  // console.log(`res`, res);
});
const isEmailSend = ref(false);

async function onBack() {
  router.push({ name: "login" });
}
async function onForgot() {
  isAuthNoError.value = validEmail(email.value);

  if (!isAuthNoError.value) {
    authErrorMessage.value = "Invalid email";
    return;
  }
  if (!isAuthNoError.value) {
    authErrorMessage.value = "Invalid email";
    return;
  }

  let res = await adapter.recoverPasswordRequest({ Email: email.value });

  if (res.IsSuccess) {
    isAuthNoError.value = true;
    isEmailSend.value = true;
  } else {
    isAuthNoError.value = false;
    authErrorMessage.value = "User not found!";
  }
  // const res = await adapter.forgetPassword({ });
  // isAuthNoError.value = res != null;
  // if (res == null)
  // notify({
  // 	text: "sdfg sdfgjksdfhg sdfgkhjs dlfkghlskdjfhg lsjdhfglkj ",
  // 	title: "Error",
  // 	type: "error",
  // });

  // instance.appContext.config.globalProperties.$notify({
  // 	text: "Маршрут успешно изменен!",
  // });
  // instance.appContext.config.globalProperties.$notify({
  // 	text: "Маршрут успешно изменен!",
  // });
}
function validEmail(value: string): boolean {
  // Регулярное выражение для проверки валидности email
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // Проверяем, что строка не пуста и соответствует паттерну
  return emailPattern.test(value);
  // Проверяем, что строка не пуста и соответствует паттерну
  return emailPattern.test(value);
}

return (_ctx: any,_cache: any) => {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_layout_without_sidebar = _resolveComponent("layout-without-sidebar")!

  return (_openBlock(), _createBlock(_component_layout_without_sidebar, {
    isShowSideBar: false,
    isLogin: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, "  " + _toDisplayString(_ctx.$t("forgot-password.forgot-password")), 1),
            (!isEmailSend.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("forgot-password.descriptions")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("forgot-password.descriptions1")), 1))
          ]),
          (!isEmailSend.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_ui_input, {
                  modelValue: email.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  type: "email",
                  headerText: _ctx.$t('Your email address'),
                  warningMsg: _ctx.$t('FillThisField'),
                  required: ""
                }, null, 8, ["modelValue", "headerText", "warningMsg"])
              ]))
            : _createCommentVNode("", true),
          (!isAuthNoError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(authErrorMessage.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (!isEmailSend.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "ui_continue_button",
                  onClick: onForgot
                }, [
                  _createTextVNode("  "),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("forgot-password.Send")), 1)
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "ui_continue_button",
                  onClick: onBack
                }, [
                  _createTextVNode("  "),
                  _hoisted_10
                ]))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})